import { render, staticRenderFns } from "./VaimoSocialLogin.vue?vue&type=template&id=5182e610&"
import script from "./VaimoSocialLogin.vue?vue&type=script&lang=ts&"
export * from "./VaimoSocialLogin.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoSocialLogin.vue?vue&type=style&index=0&id=5182e610&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports